function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("metadata", null, "Svg Vector Icons : http://www.onlinewebfonts.com/icon");

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
}, React.createElement("path", {
  d: "M4875.5,4999.2c-70.9-32.6-134.1-99.6-160.9-170.5c-15.3-38.3-21.1-1342.7-21.1-4309.7v-4256.1l-693.4,693.4c-750.8,748.9-737.4,737.4-909.8,704.9c-93.9-17.2-208.8-132.2-226-226c-34.5-176.2-69-134.1,982.6-1187.6c534.4-536.3,994.1-986.4,1022.8-1001.8c67-34.5,193.5-34.5,260.5,0c28.7,15.3,488.4,465.4,1022.9,1001.8C7204.7-2698.9,7170.2-2741,7135.7-2564.8c-17.2,93.8-132.2,208.8-226,226c-172.4,32.6-159,44.1-907.9-704.9l-695.3-693.4l-3.8,4284.8l-5.7,4284.8l-40.2,51.7c-21.1,28.7-61.3,70.9-88.1,90C5103.4,5022.2,4952.1,5035.6,4875.5,4999.2z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/sort-arrow-down.af129b12.svg";
export { SvgComponent as ReactComponent };